import { render, staticRenderFns } from "./ubtraffic.vue?vue&type=template&id=1d1eb1de&"
import script from "./ubtraffic.vue?vue&type=script&lang=js&"
export * from "./ubtraffic.vue?vue&type=script&lang=js&"
import style0 from "./ubtraffic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports